export default ({ yAxisTitle }) => ({
  yAxis: {
    title: {
      text: yAxisTitle
    },
  },
});
